import { translate } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { languages } from 'src/app/demo/constants/languages';
import { Policy } from 'src/app/demo/models/common-data-types';
import { CustomersService } from 'src/app/demo/service/customers.service';
import { LanguageService } from 'src/app/demo/service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';
import { showErrorToast } from 'src/app/demo/utilities/toast-utils';

@Component({
  selector: 'app-kyc-policies-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    TableModule,
    ButtonModule,
    NgxTranslateModule,
  ],
  templateUrl: './kyc-policies-list.component.html',
  styleUrl: './kyc-policies-list.component.scss',
})
export class KycPoliciesListComponent {
  @Input() customerId!: string;
  policies!: Policy[];
  languages: any[] = languages;
  selectedLanguage!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomersService,
    private languageService: LanguageService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.fetchCustomerProfile()
    this.initializeLocale();
  }

  initializeLocale() {
    this.languageService.currentLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.setLanguage(this.selectedLanguage);
    });
  }

  setLanguage(language: string) {
    this.translateService.use(language);
    this.languageService.setLanguage(language);
  }

  fetchCustomerProfile() {
    this.customerService.fetchCustomerPolicies(this.customerId).subscribe({
      next: value => {
        this.policies = value;
      },
      error: err => {
        showErrorToast(this.translate.instant(err.error.messageKey), this.messageService, this.translate)
      }
    })
  }
}
